import React from 'react';
import galleries from '../data/galleries.json';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import './Slideshow.scss'; // Custom styles for the slideshow

const Slideshow = ({ locationId = "shared" }) => {
    // function to detect if on mobile device

    const images = galleries[locationId] || galleries.shared;

    return (
        <div className="slideshow-container">
            <ImageGallery
                items={images}
                showPlayButton={false}
                slideInterval={15000}
                showThumbnails={false}
                lazyLoad={true}
                showFullscreenButton={false}
                autoPlay={false}

            />
        </div>
    );
};

export default Slideshow;
